import React from 'react'
import { MyOrganizationDetail as MyOrganizationDetailForm } from 'containers/forms/my-organization'

const MyOrganizationDetail = props => <MyOrganizationDetailForm {...props} />

export default MyOrganizationDetail
